import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../../../components/MaterialBox";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../../components/MaterialInput";
import { FormControl, FormHelperText, Icon } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import { useUserDetails } from "../../../../../../context/auth";
const SalaryDetails = ({
  employeeData,
  handleEmployeeDataChange,

  togglePage,
}) => {
  const { validation, validationMessages } = useUserDetails();

  const [ifscDetails, setIfscDetails] = useState({
    bankName: "IOB",
    branchName: "Tirupur branch",
  });

  return (
    <MaterialBox>
      <MaterialTypography variant="h5">Salary Details</MaterialTypography>
      <Grid container spacing={1}>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Basic Amount <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.232"
            name="basicAmount"
            value={employeeData.basicAmount}
            onChange={handleEmployeeDataChange}
            error={employeeData.basicAmountStatus === "error" ? true : false}
            success={
              employeeData.basicAmountStatus === "success" ? true : false
            }
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.basicAmountStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.basicAmount && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.basicAmount}
            </label>
          )}
        </Grid>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              DA Amount <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.232"
            name="daAmount"
            value={employeeData.daAmount}
            onChange={handleEmployeeDataChange}
            error={employeeData.daAmountStatus === "error" ? true : false}
            success={employeeData.daAmountStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.daAmountStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.daAmount && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.daAmount}
            </label>
          )}
        </Grid>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Meal Amount Per Day <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.34"
            name="mealsAmount"
            value={employeeData.mealsAmount}
            onChange={handleEmployeeDataChange}
            error={employeeData.mealsAmountStatus === "error" ? true : false}
            success={
              employeeData.mealsAmountStatus === "success" ? true : false
            }
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.mealsAmountStatus === "error" ? (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          ) : null}
          {employeeData.isIfscVerifyStatus === "success" && (
            <FormControl>
              <FormHelperText>
                <MaterialTypography
                  variant="caption"
                  fontWeight="bold"
                  color="success"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CheckIcon />
                  &nbsp; Verified
                  <MaterialTypography
                    variant="caption"
                    fontWeight="bold"
                    color="success"
                    ml={2}
                  >
                    {ifscDetails?.bankName}, {ifscDetails?.branchName}
                  </MaterialTypography>
                </MaterialTypography>
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.mealsAmount && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.mealsAmount}
            </label>
          )}
        </Grid>


            <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              HRA Amount <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.34"
            name="hraAmount"
            value={employeeData.hraAmount}
            onChange={handleEmployeeDataChange}
            error={employeeData.hraAmountStatus === "error" ? true : false}
            success={
              employeeData.hraAmountStatus === "success" ? true : false
            }
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.hraAmounttStatus === "error" ? (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          ) : null}
          {employeeData.isIfscVerifyStatus === "success" && (
            <FormControl>
              <FormHelperText>
                <MaterialTypography
                  variant="caption"
                  fontWeight="bold"
                  color="success"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CheckIcon />
                  &nbsp; Verified
                  <MaterialTypography
                    variant="caption"
                    fontWeight="bold"
                    color="success"
                    ml={2}
                  >
                    {ifscDetails?.bankName}, {ifscDetails?.branchName}
                  </MaterialTypography>
                </MaterialTypography>
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.mealsAmount && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.mealsAmount}
            </label>
          )}
        </Grid>

        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              OT Amount Per Hour <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.44"
            name="otAmount"
            value={employeeData.otAmount}
            onChange={handleEmployeeDataChange}
            error={employeeData.otAmountStatus === "error" ? true : false}
            success={employeeData.otAmountStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.otAmountStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.otAmount && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.otAmount}
            </label>
          )}
        </Grid>

        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Shift Paisa <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.66"
            name="shiftPaisa"
            value={employeeData.shiftPaisa}
            onChange={handleEmployeeDataChange}
            error={employeeData.shiftPaisaStatus === "error" ? true : false}
            success={employeeData.shiftPaisaStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.shiftPaisaStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.shiftPaisa && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.shiftPaisa}
            </label>
          )}
        </Grid>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Bus Fare <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.766"
            name="busFare"
            value={employeeData.busFare}
            onChange={handleEmployeeDataChange}
            error={employeeData.busFareStatus === "error" ? true : false}
            success={employeeData.busFareStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.busFareStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.busFare && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.busFare}
            </label>
          )}
        </Grid>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Attendance Amount <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.766"
            name="attendanceAmount"
            value={employeeData.attendanceAmount}
            onChange={handleEmployeeDataChange}
            error={
              employeeData.attendanceAmountStatus === "error" ? true : false
            }
            success={
              employeeData.attendanceAmountStatus === "success" ? true : false
            }
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.attendanceAmountStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.attendanceAmount && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.attendanceAmount}
            </label>
          )}
        </Grid>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              PF Amount <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.1000"
            name="pfamount"
            value={employeeData.pfamount}
            onChange={handleEmployeeDataChange}
            error={employeeData.pfamountStatus === "error" ? true : false}
            success={employeeData.pfamountStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.pfamountStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.attendanceAmount && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.attendanceAmount}
            </label>
          )}
        </Grid>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              ESI Amount <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.700"
            name="esiamount"
            value={employeeData.esiamount}
            onChange={handleEmployeeDataChange}
            error={employeeData.esiamountStatus === "error" ? true : false}
            success={employeeData.esiamountStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.esiamountStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 6 digits.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.attendanceAmount && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.attendanceAmount}
            </label>
          )}
        </Grid>
      </Grid>
    </MaterialBox>
  );
};

export default SalaryDetails;
